import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center align-middle" }
const _hoisted_2 = { class: "d-none d-md-block m-0 p-0" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "d-flex justify-content-center" }
const _hoisted_5 = { class: "d-md-none" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "ms-1 d-md-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("td", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.schedule.routes.scheduleEdit,
        class: _normalizeClass(["btn fs-small lh-sm w-100 py-1 mb-1", _ctx.schedule.statusClass.buttonClass])
      }, " 内容 ", 10, _hoisted_3),
      (_ctx.schedule.isShowRentalContract)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRentalContractModal(_ctx.schedule.id))),
            class: _normalizeClass(["js-colorbox-iframe btn fs-small lh-sm w-100 py-1", _ctx.schedule.statusClass.buttonClass])
          }, " 契約書 ", 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: _ctx.schedule.routes.scheduleEdit,
          class: _normalizeClass(["btn fs-small lh-sm w-100 py-1 mb-1 text-nowrap btn-sm", _ctx.schedule.statusClass.buttonClass])
        }, " 内容 ", 10, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.schedule.isShowRentalContract)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRentalContractModal(_ctx.schedule.id))),
              class: _normalizeClass(["js-colorbox-iframe btn fs-small lh-sm w-100 py-1 text-nowrap btn-sm", _ctx.schedule.statusClass.buttonClass])
            }, " 契約書 ", 2))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}